import fetchWithUuid from "./fetchWithUuid";
import { getLoyaltyCode } from "../fastflowUtils";
import { checkErrorAllowSeeOther } from "./checkError";
import { actionTypes, apiStatuses, CreateOrder, CreateOrderReturn, Deferred, validationErrors } from "./Actions";

const createOrder: CreateOrder = ({
                                           companyContactEmail,
                                           companyContactFirstName,
                                           companyContactLastName,
                                           companyContactPhone,
                                           spidId,
                                           sig,
                                           productInfo,
                                           paymentMethodId,
                                           phoneNumber,
                                           address,
                                           referer,
                                           redirectUri,
                                           purchasedSubscriptionId,
                                           paymentType,
                                           companyPays,
                                           loyaltyPartner,
                                           receiptPageUrl,
                                           vippsPhoneNumber,
                                         }) => dispatch => {
  const failedCallback = (error: any) => {
    const errorData = error.data;
    let errorJson;
    try {
      errorJson = (errorData && JSON.parse(errorData)) || {};
    } catch (e) {
      errorJson = {};
    }
    const data = Object.assign({}, error, {
      ...errorJson,
      errorCode: errorJson.errorCode || 0,
      header: errorJson.summary || '',
      message: errorJson.message
    });
    if (data.status === 409) {
      dispatch({
        data,
        status: apiStatuses.CONFLICT,
        type: actionTypes.CREATE_ORDER
      });
    } else if (
      data.status === 422 &&
      JSON.stringify(data).indexOf(validationErrors.PURCHASE_FAILED) !== -1
    ) {
      dispatch({
        data,
        status: apiStatuses.VALIDATION_ERROR,
        type: actionTypes.CREATE_ORDER
      });
    } else if (data.status === 422 && data.redirectUrl) {
      window.location.href = data.redirectUrl;
      return createOrderDeferred.resolve(data);
    } else {
      dispatch({
        data,
        status: apiStatuses.ERROR,
        type: actionTypes.CREATE_ORDER
      });
    }
    return createOrderDeferred.reject(data);
  };

  const isCard: boolean = paymentType !== 'STREX';
  const createOrderDeferred = new Deferred<CreateOrderReturn>();
  dispatch({
    status: apiStatuses.LOADING,
    type:
      isCard && !companyPays
        ? actionTypes.SET_PAYEX_URL
        : actionTypes.CREATE_ORDER
  });

  if (paymentMethodId === undefined) {
    paymentMethodId = '-1';
  }

  const sentPaymentMethodId = (paymentMethodId && parseInt(paymentMethodId, 10)) || -1;
  const sentRedirectUri = sentPaymentMethodId === -4 ? redirectUri
    .replace(/(\?spidId=[^&]+).*/, "$1")
    .replace(/\?.+&(spidId=[^&]+).*/, "?$1") : redirectUri;
  fetchWithUuid(
    `/bestilling/c/${productInfo.owningClient}/api/v2/ff/users/${spidId}/orders.json`,
    {
      body: JSON.stringify({
        apartmentNumber: address.apartmentNumber,
        cellphone: phoneNumber,
        city: address.city,
        coAddress: address.coAddress,
        ...(companyContactEmail && { companyContactEmail }),
        ...(companyContactFirstName && { companyContactFirstName }),
        ...(companyContactLastName && { companyContactLastName }),
        ...(companyContactPhone && { companyContactPhone }),
        companyName: (companyPays && companyPays.companyName) || '',
        diId: address.deliveryPointId,
        entrance: address.entrance,
        floor: address.floor,
        invoiceCity: (companyPays && companyPays.invoiceCity) || '',
        invoiceStreet: (companyPays && companyPays.invoiceStreet) || '',
        invoiceZipCode: (companyPays && companyPays.invoiceZipCode) || '',
        loyaltyPartner,
        loyaltyPartnerCardNumber: getLoyaltyCode(),
        offersAccepted: false,
        organizationNumber:
          (companyPays && companyPays.organizationNumber) || '',
        paymentMethodId: sentPaymentMethodId,
        paymentType,
        price: productInfo.price,
        productId: productInfo.productId,
        productMappingId: productInfo.productMappingId,
        purchasedSubscriptionId:
          (purchasedSubscriptionId && parseInt(purchasedSubscriptionId, 10)) ||
          null,
        receiptPageUrl,
        redirectUri: sentRedirectUri,
        reference: (companyPays && companyPays.reference) || '',
        referer,
        street: address.streetAddress,
        streetNumber: address.houseNumber,
        subscriptionConfigurationId: productInfo.subscriptionConfigurationId,
        subscriptionTypeId: productInfo.subscriptionTypeId,
        vippsPhoneNumber,
        zipCode: address.zipCode,
      }, null, 2),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-score-spid-sig': sig
      },
      method: 'POST'
    }
  )
    .then(checkErrorAllowSeeOther)
    .then(res => res.json())
    .then(data => {
      if (isCard && !companyPays) {
        dispatch({
          data,
          status: apiStatuses.SUCCESS,
          type: actionTypes.SET_PAYEX_URL
        });
      } else {
        dispatch({
          data,
          status: apiStatuses.SUCCESS,
          type: actionTypes.CREATE_ORDER
        });
      }
      return createOrderDeferred.resolve(data);
    })
    .catch(failedCallback);
  return createOrderDeferred.promise;
};

export default createOrder;
